/**
 * LineShoppingSection Component
 * Toggle for odds comparison feature (Pro+ only)
 */

import type { User } from '@contexts/AuthContext';
import type { ReactElement } from 'react';

interface LineShoppingSectionProps {
  // Data
  user: User | null;

  // Handlers
  onUpdatePreferences: (preferences: { enableLineComparison: boolean }) => Promise<void>;
}

export function LineShoppingSection({
  user,
  onUpdatePreferences,
}: LineShoppingSectionProps): ReactElement {
  return (
    <section className="mb-6">
      <h3 className="text-lg font-medium text-theme-text mb-2">Line Shopping</h3>
      <div className="bg-theme-surface rounded-lg p-4 border border-theme-border">
        <label className="flex items-center justify-between cursor-pointer">
          <div>
            <div className="text-sm font-medium text-theme-text">Show best line badges</div>
            <div className="text-xs text-theme-text-tertiary mt-0.5">
              Compare odds across sportsbooks on each leg
            </div>
          </div>
          <button
            type="button"
            onClick={() =>
              onUpdatePreferences({
                enableLineComparison: !(user?.preferences?.enableLineComparison ?? true),
              })
            }
            className={`relative w-10 h-5 shrink-0 rounded-full transition-colors ${
              (user?.preferences?.enableLineComparison ?? true)
                ? 'bg-theme-primary'
                : 'bg-theme-border'
            }`}
          >
            <span
              className={`absolute top-0.5 left-0.5 w-4 h-4 rounded-full bg-white transition-transform ${
                (user?.preferences?.enableLineComparison ?? true) ? 'translate-x-5' : ''
              }`}
            />
          </button>
        </label>
      </div>
    </section>
  );
}
